export default function messageOnFindAllActions(status) {
    let message

    switch (status) {
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos buscar as actions.'
            break
        default:
            message = 'Ops! Algo de estranho ocorreu e não conseguimos buscar as actions.'
    }

    return message
}
